/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {MouseEventHandler} from 'react';
import {Chip} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {MaterialExitCloseIcon} from '../../icons/MaterialExitCloseIcon';
import {dlsColor, dlsTypography} from '../../theme/theme';
import {DLSTheme, IconSize} from '../../types/types';

export interface ComponentProps {
  disabled?: boolean;
  showFullLabel?: boolean;
  label: string;
  onDelete?: MouseEventHandler;
}

const MAX_CHIP_PIXEL_LENGTH = 175;

const useStyles = makeStyles((theme: DLSTheme) => ({
  root : {
    backgroundColor : theme.dls.colors?.paleBlue2 || dlsColor('paleBlue2'),
    maxWidth        : ({maxWidth}) => maxWidth && `${MAX_CHIP_PIXEL_LENGTH}px`,
    whiteSpace      : 'nowrap',
    overflow        : 'hidden',
    textOverflow    : 'ellipsis'
  },
  label : {
    ...theme.dls.alt.typography.label3,
    color : dlsColor('aaBlue')
  },
  deleteIcon : {
    paddingTop : '6px'
  }
}));

/**
 * Primary color based chips with the option to delete them.
 */
export const PrimaryChip = ({
  label,
  onDelete,
  showFullLabel = false,
  disabled = false
}: ComponentProps) => {
  const {iconMargin} = dlsTypography('chips');
  const classes = useStyles({iconMargin, maxWidth: !showFullLabel});
  return (
    <Chip disabled={disabled}
      label={label}
      onDelete={onDelete}
      variant={'outlined'}
      color={'primary'}
      classes={{
        root       : classes.root,
        label      : classes.label,
        deleteIcon : classes.deleteIcon
      }}
      deleteIcon={(
        <div>
          <MaterialExitCloseIcon size={IconSize.small} color={dlsColor('aaBlue')} />
        </div>
      )} />
  );
};

export default PrimaryChip;
